import type { MessageVM } from "@propertelligent/client-api";
import { NotificationType, PubSub, TopicsEnum } from "./pubsub";

// `whatsAppWarning` is not in the generated client-api `MessageVM` until it is regenerated.
type MessageWithWhatsAppWarning = MessageVM & { whatsAppWarning?: string | null };

export const notifyWhatsAppWarning = (message?: MessageVM | null): void => {
  const warning = (message as MessageWithWhatsAppWarning | null | undefined)?.whatsAppWarning;
  if (typeof warning !== "string" || warning.trim() === "") return;

  PubSub.publish(TopicsEnum.Notification.toString(), {
    message: warning,
    type: NotificationType.Warning,
  });
};
